import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

// Styled components (unchanged)
const DropDownButtonLeft = styled.div`
  padding: 2px;
  display: flex;
  height: 100%;
  width: 70%;
  align-items: center;
  justify-content: center;
  border-right: 1px solid gray;
  cursor: pointer;
  color: #99b0ad;
  font-size: 12px;
  font-weight: bold;
  background-color: ${(props) => (props.isPeopleAndZero ? "#EE754C" : "white")};
  border-radius: 5px 0 0 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DropDownButtonRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: gray;
  text-align: center;
  width: 30%;
  cursor: pointer;
  background-color: white;
  border-radius: 0 5px 5px 0;
`;

function DropDownButton({
  handleOptionChange,
  initialOption,
  isPeople = false,
  update,
  setUpdate = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialOption || 1);
  const [options, setOptions] = useState([]);
  const dropdownMenuRef = useRef(null);
  const selectedRef = useRef(null);

  const INITIAL_LOAD = 20; // Load 20 numbers initially
  const INCREMENT_BY = 10; // Add 10 more numbers every time you scroll to bottom

  useEffect(() => {
    const initialOptions = Array.from(
      { length: INITIAL_LOAD },
      (_, i) => i + 1
    );
    setOptions(initialOptions);
  }, []);

  useEffect(() => {
    if (isOpen && selectedRef.current) {
      selectedRef.current.scrollIntoView({ block: "center" });
    }
  }, [isOpen]);

  const handleSelect = (option, e) => {
    e.preventDefault();
    setSelectedOption(option);
    handleOptionChange(option);
    setIsOpen(false);

    if (setUpdate) {
      setUpdate(update + 1);
    }
  };

  const handleOpen = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleScroll = () => {
    const dropdown = dropdownMenuRef.current;
    if (!dropdown) return;

    const { scrollTop, scrollHeight, clientHeight } = dropdown;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      addMoreOptions();
    }
  };

  const addMoreOptions = () => {
    const currentMax = options[options.length - 1] || 0;
    const newOptions = Array.from(
      { length: INCREMENT_BY },
      (_, i) => currentMax + i + 1
    );

    setOptions((prevOptions) => [...prevOptions, ...newOptions]);
  };

  return (
    <div className="form-control-people" onClick={(e) => handleOpen(e)}>
      <DropDownButtonLeft isPeopleAndZero={isPeople && selectedOption === 0}>
        {isPeople && selectedOption === 0 ? "nº Pessoas" : selectedOption}
      </DropDownButtonLeft>

      <DropDownButtonRight>
        <div className={`arrow-icon ${isOpen ? "rotate-menu-arrow" : ""}`}>
          <FontAwesomeIcon
            icon={faChevronCircleDown}
            size="xl"
            color="#99B0AD"
          />
        </div>
      </DropDownButtonRight>

      {isOpen && (
        <div
          className="custom-dropdown-menu"
          ref={dropdownMenuRef}
          onScroll={handleScroll}
          style={{
            maxHeight: "200px",
            overflowY: "auto",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "white",
            position: "absolute",
            zIndex: 9999,
          }}
        >
          {options.map((option, index) => (
            <div
              key={index}
              onClick={(e) => handleSelect(option, e)}
              ref={option === selectedOption ? selectedRef : null}
              className={`dropdown-menu-item ${
                option === selectedOption ? "selected" : ""
              }`}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DropDownButton;
